// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Фон модалки */
.cm-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

/* Обёртка всей модалки */
.cm-modal {
  position: relative;           /* для абсолютного позиционирования кнопки */
  background: #fff;
  border-radius: 8px;
  width: 360px;
  max-width: 90%;
  max-height: 80vh;            /* ограничиваем общую высоту */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  overflow: hidden;             /* список будет скроллиться внутри */
  display: flex;
  flex-direction: column;
  padding-bottom: 52px;         /* резервируем место под кнопку закрыть */
}

/* Заголовок */
.cm-title {
  margin: 0;
  padding: 16px;
  font-size: 18px;
  text-align: center;
  border-bottom: 1px solid #eee;
  flex: 0 0 auto;
}

/* Секция с контактами */
.cm-contacts {
  padding: 12px 16px;
  font-size: 14px;
  border-bottom: 1px solid #eee;
  flex: 0 0 auto;             /* фиксированная по высоте */
}
.cm-contacts p {
  margin: 4px 0;
}

/* Обёртка для списка комментариев */
.cm-list-container {
  flex: 1 1 auto;             /* занимает всё оставшееся пространство */
  overflow-y: auto;           /* скроллится только список */
  padding: 8px 0;
}

/* Сами элементы списка */
.cm-list {
  list-style: none;
  margin: 0;
  padding: 0 16px;
}
.cm-list-item + .cm-list-item {
  margin-top: 6px;
}

/* Кнопки-шаблоны */
.cm-list-btn {
  width: 100%;
  background: #f7f7f7;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 8px 12px;
  font-size: 14px;
  text-align: left;
  cursor: pointer;
  transition: background 0.2s;
}
.cm-list-btn:hover {
  background: #eaeaea;
}

/* Сообщение об ошибке */
.cm-error {
  padding: 12px 16px;
  font-size: 14px;
  color: red;
  text-align: center;
  flex: 0 0 auto;
}

/* Кнопка закрыть */
.cm-close-btn {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;                   /* приклеена к низу модалки */
  background: #007bff;
  color: #fff;
  border: none;
  padding: 12px;
  font-size: 14px;
  cursor: pointer;
  border-top: 1px solid #eee;
  width: 100%;
  border-radius: 0 0 8px 8px;
  z-index: 5;                  /* поверх списка */
}
`, "",{"version":3,"sources":["webpack://./src/modules/Dispatcher/Undelivered/components/CommentModal.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA,yBAAyB;AACzB;EACE,kBAAkB,YAAY,4CAA4C;EAC1E,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,gBAAgB,aAAa,8BAA8B;EAC3D,yCAAyC;EACzC,gBAAgB,cAAc,oCAAoC;EAClE,aAAa;EACb,sBAAsB;EACtB,oBAAoB,UAAU,yCAAyC;AACzE;;AAEA,cAAc;AACd;EACE,SAAS;EACT,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,cAAc,cAAc,4BAA4B;AAC1D;AACA;EACE,aAAa;AACf;;AAEA,oCAAoC;AACpC;EACE,cAAc,cAAc,yCAAyC;EACrE,gBAAgB,YAAY,6BAA6B;EACzD,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,SAAS;EACT,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS,oBAAoB,6BAA6B;EAC1D,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,eAAe;EACf,eAAe;EACf,0BAA0B;EAC1B,WAAW;EACX,0BAA0B;EAC1B,UAAU,mBAAmB,kBAAkB;AACjD","sourcesContent":["/* Фон модалки */\r\n.cm-backdrop {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.4);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n}\r\n\r\n/* Обёртка всей модалки */\r\n.cm-modal {\r\n  position: relative;           /* для абсолютного позиционирования кнопки */\r\n  background: #fff;\r\n  border-radius: 8px;\r\n  width: 360px;\r\n  max-width: 90%;\r\n  max-height: 80vh;            /* ограничиваем общую высоту */\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\r\n  overflow: hidden;             /* список будет скроллиться внутри */\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding-bottom: 52px;         /* резервируем место под кнопку закрыть */\r\n}\r\n\r\n/* Заголовок */\r\n.cm-title {\r\n  margin: 0;\r\n  padding: 16px;\r\n  font-size: 18px;\r\n  text-align: center;\r\n  border-bottom: 1px solid #eee;\r\n  flex: 0 0 auto;\r\n}\r\n\r\n/* Секция с контактами */\r\n.cm-contacts {\r\n  padding: 12px 16px;\r\n  font-size: 14px;\r\n  border-bottom: 1px solid #eee;\r\n  flex: 0 0 auto;             /* фиксированная по высоте */\r\n}\r\n.cm-contacts p {\r\n  margin: 4px 0;\r\n}\r\n\r\n/* Обёртка для списка комментариев */\r\n.cm-list-container {\r\n  flex: 1 1 auto;             /* занимает всё оставшееся пространство */\r\n  overflow-y: auto;           /* скроллится только список */\r\n  padding: 8px 0;\r\n}\r\n\r\n/* Сами элементы списка */\r\n.cm-list {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0 16px;\r\n}\r\n.cm-list-item + .cm-list-item {\r\n  margin-top: 6px;\r\n}\r\n\r\n/* Кнопки-шаблоны */\r\n.cm-list-btn {\r\n  width: 100%;\r\n  background: #f7f7f7;\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n  padding: 8px 12px;\r\n  font-size: 14px;\r\n  text-align: left;\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n}\r\n.cm-list-btn:hover {\r\n  background: #eaeaea;\r\n}\r\n\r\n/* Сообщение об ошибке */\r\n.cm-error {\r\n  padding: 12px 16px;\r\n  font-size: 14px;\r\n  color: red;\r\n  text-align: center;\r\n  flex: 0 0 auto;\r\n}\r\n\r\n/* Кнопка закрыть */\r\n.cm-close-btn {\r\n  position: absolute;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;                   /* приклеена к низу модалки */\r\n  background: #007bff;\r\n  color: #fff;\r\n  border: none;\r\n  padding: 12px;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n  border-top: 1px solid #eee;\r\n  width: 100%;\r\n  border-radius: 0 0 8px 8px;\r\n  z-index: 5;                  /* поверх списка */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
